import { useCallback, useState } from 'react';
import { useLocation } from 'react-router';
export function useShareUrl(basename) {
  var location = useLocation();
  var shareUrl = window.location.origin + basename + location.pathname + location.search;
  return shareUrl;
}
var FLASH_TIME = 1000;
export function useCopySuccess() {
  var _useState = useState(false),
      showSuccess = _useState[0],
      setShowSuccess = _useState[1];

  var onCopy = useCallback(function () {
    setShowSuccess(true);
    var timeout = setTimeout(function () {
      setShowSuccess(false);
    }, FLASH_TIME);
    return function () {
      if (timeout) {
        clearTimeout(timeout);
      }

      setShowSuccess(false);
    };
  }, [setShowSuccess]);
  return {
    onCopy: onCopy,
    showSuccess: showSuccess
  };
}